<template>
  <footer>
    <section class="cols_container">
      <div class="col">
        <ul>
          <li v-for="title in fritsColLinks" :key="title">
            <router-link active-class="active" exact :to="title.route">{{
              title.name
            }}</router-link>
          </li>
        </ul>
      </div>
      <div class="col">
        <ul>
          <li v-for="title in secondColLink" :key="title">
            <router-link active-class="active" exact :to="title.route">{{
              title.name
            }}</router-link>
          </li>
        </ul>
        <p>
          <a :href="'mailto:' + contactData.email">
            <i class="far fa-envelope" />{{ contactData.email }}
          </a>
        </p>
        <p>
          <a :href="'tel:' + contactData.phoneNumber"
            ><i class="fas fa-phone-volume" />{{ contactData.phoneNumber }}</a
          >
        </p>
        <div class="social_accounts">
          <a :href="contactData.socialLinks.instagram" target="_blank">
            <i class="fab fa-instagram"></i
          ></a>
          <a :href="contactData.socialLinks.youtube" target="_blank">
            <i class="fab fa-youtube"></i
          ></a>
          <a :href="contactData.socialLinks.facebook" target="_blank">
            <i class="fab fa-facebook-f"></i
          ></a>
        </div>
      </div>
      <div class="col">
        <img
          src="@/assets/whiteLogo.png"
          alt="Code Clinic Logo"
          loading="lazy"
          draggable="false"
        />
        <p>{{ contactData.logoCaption }}</p>
      </div>
    </section>
    <p class="copyRight">{{ contactData.copyRightText }}</p>
  </footer>
</template>

<script>
import store from "@/store";
export default {
  name: "Footer",
  data() {
    return {};
  },

  computed: {
    alllinks() {
      const { lang } = store.state;
      return store.state[lang].navbarTitles;
    },
    fritsColLinks() {
      const { home, ourWorks, ourClients, whoWeAre, policies } = this.alllinks;
      return { home, ourWorks, ourClients, whoWeAre, policies };
    },
    secondColLink() {
      const { contactUs } = this.alllinks;
      return { contactUs };
    },
    contactData() {
      const { lang } = store.state;
      return store.state[lang].footerContent;
    },
  },
};
</script>

<style></style>
